import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { memo, useState, useRef, useEffect, cloneElement } from 'react';
import { useFormContext } from 'react-hook-form';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function getValue(target, _ref) {
  var isCheckbox = _ref.isCheckbox;

  if (Array.isArray(target)) {
    return target;
  }

  return target ? isCheckbox ? target.checked : target.value : target;
}

var RHFInput = memo(function (_a) {
  var setValueFromProp = _a.setValue,
      registerFromProp = _a.register,
      unregisterFromProp = _a.unregister,
      name = _a.name,
      rules = _a.rules,
      _a$mode = _a.mode,
      mode = _a$mode === void 0 ? 'onSubmit' : _a$mode,
      as = _a.as,
      onChange = _a.onChange,
      onBlur = _a.onBlur,
      type = _a.type,
      value = _a.value,
      defaultValue = _a.defaultValue,
      defaultChecked = _a.defaultChecked,
      onChangeName = _a.onChangeName,
      onChangeEvent = _a.onChangeEvent,
      onBlurName = _a.onBlurName,
      onBlurEvent = _a.onBlurEvent,
      rest = __rest(_a, ["setValue", "register", "unregister", "name", "rules", "mode", "as", "onChange", "onBlur", "type", "value", "defaultValue", "defaultChecked", "onChangeName", "onChangeEvent", "onBlurName", "onBlurEvent"]);

  var isCheckbox = type === 'checkbox';
  var isOnChange = mode === 'onChange';
  var isOnBlur = mode === 'onBlur';
  var defaultData = isCheckbox ? defaultChecked === undefined ? false : defaultChecked : defaultValue === undefined ? '' : defaultValue;

  var _useState = useState(defaultData),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var valueRef = useRef(defaultData);
  var methods = useFormContext() || {};
  var setValue = setValueFromProp || methods.setValue;
  var register = registerFromProp || methods.register;
  var unregister = unregisterFromProp || methods.unregister;

  var commonTask = function commonTask(target) {
    var data = getValue(target, {
      isCheckbox: isCheckbox
    });
    setInputValue(data);
    valueRef.current = data;
    return data;
  };

  var eventWrapper = function eventWrapper(event, eventName) {
    return function () {
      for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      var data = commonTask(event(arg));
      setValue(name, data, isOnChange && eventName === 'onChange' || isOnBlur && eventName === 'onBlur');
    };
  };

  var handleChange = function handleChange(e) {
    var data = commonTask(e && e.target ? e.target : e);
    setValue(name, data, isOnChange);

    if (onChange) {
      onChange(e);
    }
  };

  var handleBlur = function handleBlur(e) {
    var data = commonTask(e && e.target ? e.target : e);
    setValue(name, data, isOnBlur);

    if (onBlur) {
      onBlur(e);
    }
  };

  useEffect(function () {
    register(Object.defineProperty({
      name: name,
      type: type
    }, 'value', {
      set: function set(data) {
        setInputValue(data);
        valueRef.current = data;
      },
      get: function get() {
        return valueRef.current;
      }
    }), Object.assign({}, rules));
    return function () {
      if (unregister) {
        unregister(name);
      }
    };
  }, [register, unregister, name]); // eslint-disable-line react-hooks/exhaustive-deps

  return cloneElement(as, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, onChangeEvent ? _defineProperty({}, onChangeName || 'onChange', eventWrapper(onChangeEvent, 'onChange')) : {
    onChange: handleChange
  }), isOnBlur ? onBlurEvent ? _defineProperty({}, onBlurName || 'onBlur', eventWrapper(onBlurEvent, 'onBlur')) : {
    onBlur: handleBlur
  } : {}), {
    value: value || inputValue
  }), isCheckbox ? {
    checked: inputValue
  } : {}), rest));
});
export { RHFInput };